import { createReducer } from "reduxsauce"
import actionCreator from "helpers/actionCreator"

export const { Types, Creators } = actionCreator("ompnt/modules/resources", {
  open: ["settings"],
  trackAction: {
    props: ["trackType", "trackPayload"],
    track: true,
    trackType: ({ trackType }) => trackType,
    trackPayload: ({ trackPayload }) => trackPayload,
  },
  close: [],
}, {
  prefix: "ompnt/modules/dialog",
})

const DEFAULT_STATE = {
  opened: false,
  settings: {},
}

function handleOpen(state, { settings }) {
  return {
    ...state,
    opened: true,
    settings,
  }
}

function handleClose(state) {
  return {
    ...state,
    opened: false,
    settings: {},
  }
}

export default createReducer(DEFAULT_STATE, {
  [Types.OPEN]: handleOpen,
  [Types.CLOSE]: handleClose,
})
